import React, { useContext } from "react";
import { Route, Redirect } from "react-router-dom";
import useCurrentUser from "../../hooks/useCurrentUser";

const PrivateRoute = ({ component: RouteComponent, ...rest }) => {
  const currentUser = useCurrentUser();
  return (
    <Route
      {...rest}
      render={(routeProps) =>
        !!currentUser ? (
          <RouteComponent {...routeProps} />
        ) : (
          <Redirect to={"/login"} />
        )
      }
    />
  );
};

export default PrivateRoute;
